"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var SG_NRIC_1 = require("./providers/SG_NRIC");
var TW_ID_1 = require("./providers/TW_ID");
var CN_ID_1 = require("./providers/CN_ID");
var providerRegistry = {
    'SG': {
        'NRIC': SG_NRIC_1.default
    },
    'TW': {
        'ID': TW_ID_1.default
    },
    'CN': {
        'ID': CN_ID_1.default
    }
};
var IDNumber = (function () {
    function IDNumber() {
    }
    IDNumber.getValidator = function (country, document) {
        if (providerRegistry.hasOwnProperty(country)) {
            var countryValidators = providerRegistry[country];
            if (countryValidators.hasOwnProperty(document)) {
                var tool_1 = new countryValidators[document]();
                return function (id) {
                    if (!tool_1.validate) {
                        return {
                            success: false,
                            reason: "not_implemented"
                        };
                    }
                    var result = tool_1.validate(id);
                    var output = { success: result.success };
                    if (result.hasOwnProperty("reason"))
                        output.reason = types_1.ErrorCode[result.reason];
                    if (result.hasOwnProperty("extra"))
                        output.extra = result.extra;
                    return output;
                };
            }
        }
    };
    IDNumber.getGenerator = function (country, document) {
        if (providerRegistry.hasOwnProperty(country)) {
            var countryValidators = providerRegistry[country];
            if (countryValidators.hasOwnProperty(document)) {
                var tool_2 = new countryValidators[document]();
                return function () {
                    if (!tool_2.generate) {
                        return undefined;
                    }
                    return tool_2.generate();
                };
            }
        }
    };
    return IDNumber;
}());
exports.IDNumber = IDNumber;



//////////////////
// WEBPACK FOOTER
// ../dist/commonjs/IDNumber.js
// module id = 245
// module chunks = 0